import { onCLS, onFID, onFCP, onLCP, onTTFB } from "web-vitals";

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry); // CLS metric
    onFID(onPerfEntry); // FID metric
    onFCP(onPerfEntry); // FCP metric
    onLCP(onPerfEntry); // LCP metric
    onTTFB(onPerfEntry); // TTFB metric
  }
};

export default reportWebVitals;
